import Service from "../../Service";

const resource = "visit/";

export default {
    
    save(parameters, requestID) {
        return Service.post(resource + "saveRecomendationHead", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "paginationRecomendationHead", parameters, {
            params: { requestID }
        });
    },
    listRecomendation(parameters, requestID) {
        return Service.post(resource + "listVisitRecomendation", parameters, {
            params: { requestID }
        });
    }
};